<app-header [title]="title" [subtitle]="subtitle"></app-header>
<main>
  <article class="containero">
    <h1   *ngIf="projects.length==0">Nie dodałeś jeszcze projektu</h1>
    <h1   *ngIf="projects.length==1" class="one-more">Możesz dodać jeszcze tylko jeden projekt do porównania</h1>
    <div *ngFor="let project of projects, let last=last, let first=first"
      [ngClass]="{'first col': first, 'last col': (last && projects.length != 1), 'selected': project == selectedProject}">
      <img src="{{project.projectImageFile}}" (click)="selectProject(project)">
      <div class="menu">
        <a (click)="editProject(project)" mdbBtn floating="true"   color="default" matTooltip="Zmień projekt" placement="bottom" mdbWavesEffect>
          <mdb-icon fas icon="edit"></mdb-icon>
        </a>
        <a (click)="previewProject(project)" mdbBtn floating="true" color="primary" matTooltip="Podgląd" placement="bottom" mdbWavesEffect>
          <mdb-icon fas icon="eye"></mdb-icon>
        </a>
        <a (click)="onDeleteProject(project)" mdbBtn floating="true"  color="dark" matTooltip="Usuń projekt" placement="bottom" mdbWavesEffect>
          <mdb-icon fas icon="trash"></mdb-icon>
        </a>
<!--        <button (click)="editProject(project)">Zmień projekt</button>-->
<!--        <button (click)="previewProject(project)">Podgląd</button>-->
<!--        <button (click)="deleteProject(project)">Usuń projekt</button>-->
      </div>
    </div>
  </article>
</main>
<app-footer [nextEvent]="true" (clickNext)="onNextClick($event)" [prev]="prev"></app-footer>
<jw-modal id="preview-dialog">
  <span class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
      (click)="closeModal()"></span>
  <img src="" alt="Podgląd projektu" class="preview-image">
</jw-modal>

<jw-modal id="edit-dlg">
  <div class="messagebox">
      <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
              (click)="closeModal()"></button>
      <p  >Czy chcesz powrócić do edycji?</p>
      <div class="buttons">
        <button class="accept leaning" (click)="accept()">
          <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">Tak</div>
        </button>
        <button class="decline leaning" (click)="decline()">
          <div class="content">Nie</div>
        </button>
      </div>
  </div>
</jw-modal>

<jw-modal id="notice-dlg">
  <div class="messagebox">
      <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
              (click)="closeModal()"></button>
      <p  >Aby przejść dalej najpierw zaznacz jeden z projektów.</p>
      <div class="buttons">
        <button class="accept leaning" (click)="closeModal()">
          <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">OK</div>
        </button>
      </div>
  </div>
</jw-modal>

<jw-modal id="delete-dlg">
  <div class="messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
        (click)="closeModal()"></button>
    <p  >Czy na pewno usunąć projekt?</p>
    <div class="buttons">
      <button class="accept leaning" (click)="deleteProject()">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-18.png">Usuń</div>
      </button>
      <button class="accept leaning" (click)="closeModal()">
        <div class="content"><img src="assets/ikony/aplikacja-ikony-16.png">Anuluj</div>
    </button>
    </div>
  </div>
</jw-modal>
